import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Row, Col } from 'react-flexbox-grid';

export const Wrapper = styled.nav`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  box-shadow: 0 -1px 4px 0 rgba(0,0,0,0.15);
  z-index: 10;
`;

export const NavLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 12px;
  width: 100%;
`;

export const NavRow = styled(Row)`
  width: 100%;
  padding: 0;
  margin: 0;
`;

export const Column = styled(Col)`
  width: 100%;
  padding: 0;

  :nth-child(3){
    display: flex;
    justify-content: center;
  }
`;

export const IconWrapper = styled.div`
  width: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 5px;
`;

export class Navigation extends PureComponent {
  render() {
    return (
      <Wrapper className='is-hidden-desktop'>
        <NavRow around='xs'>
          <Column xs={2}>
            <NavLink to='/' active={true}>
              <IconWrapper>
                <span className='fas fa-motorcycle fa-2x'></span>
              </IconWrapper>
              Jobs
            </NavLink>
          </Column>
          <Column xs={2}>
            <NavLink to='/history' active={false}>
              <IconWrapper>
                <span className='fas fa-history fa-2x'></span>
              </IconWrapper>
              History
            </NavLink>
            <Column xs={2}>
            <NavLink to='/history' active={false}>
              <IconWrapper>
                <span className='fas fa-history fa-2x'></span>
              </IconWrapper>
              Account
            </NavLink>
          </Column>
          </Column>
        </NavRow>
      </Wrapper>
    );
  }
}

export default Navigation;